import { useState, useEffect } from "react";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  NavbarText,
  ListGroupItem,
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useAuth } from "../context/AuthContext";
import { faUser } from "@fortawesome/free-solid-svg-icons";

const Profile = () => {
  const { user, logout } = useAuth();
  const [name, setName] = useState(null);

  useEffect(() => {
    if (user) {
      setName(user.name.split(" ")[0] || "");
    }
  }, [user]);

  const handleLogout = () => {
    if (user) {
      logout();
    }
  };

  if (name && name != "") {
    return (
      <div className="d-flex align-items-center">
        <UncontrolledDropdown>
          <NavbarText className="py-0">
            <DropdownToggle tag="span" className="nav-link py-0 navbar-icon" caret>
              {name} <FontAwesomeIcon icon={faUser} />
            </DropdownToggle>
          </NavbarText>
          <DropdownMenu
            className="mt-2"
            right
            style={{
              background: "black",
              padding: 5,
              border: "gray 1px solid",
              borderRadius: 10,
              fontSize: 12,
            }}
          >
            <ListGroupItem
              tag="a"
              action
              className="d-flex justify-content-between align-items-center text-light pt-2"
              onClick={() => handleLogout()}
            >
              Logout
            </ListGroupItem>
          </DropdownMenu>
        </UncontrolledDropdown>
      </div>
    );
  } else {
    return null;
  }
};

export default Profile;
